import { SystemStyleObject, chakra } from '@chakra-ui/react'

import { GREEN_CHROMAKEY_LOGO_WIDTH, TRANSCRIPT_FULL_WIDTH_PADDING, TRANSCRIPT_PANEL_MIN_WIDTH } from 'src/components/constants'
import { shouldForwardProp } from 'src/utils/should-forward-prop'
import { VerbitLogoChromakey } from 'src/components/icons'

import { INCONSISTENCY_INDICATOR_SCALE_VAR } from './constants'

type ContainerProps = { $fontSize: number; $inconsistencyIndicatorScale: number }
export const Container = chakra<'div', ContainerProps>('div', {
    baseStyle: ({ $fontSize, $inconsistencyIndicatorScale, theme }) => {
        const tabletQuery = `@container (max-width: ${theme.breakPoints.tabletMaxWidth}px)`

        const styles: SystemStyleObject = {
            position: 'relative',
            display: 'flex',
            width: '100%',
            height: '100%',
            backgroundColor: theme.palette.transcript.appBackgroundColors[theme.appBackgroundColorIndex].colorValue,
            fontSize: `${$fontSize}px`,
            [INCONSISTENCY_INDICATOR_SCALE_VAR]: String($inconsistencyIndicatorScale),
            overflowY: 'auto',
            contain: 'strict',
            _focus: { zIndex: 1 },
            [tabletQuery]: { width: '100%', minWidth: TRANSCRIPT_PANEL_MIN_WIDTH },
        }

        return styles
    },
    shouldForwardProp,
})

export const ScrollingContainer = chakra('div', { baseStyle: { width: '100%', position: 'relative' } })

export const Scroller = chakra('div', { baseStyle: { position: 'absolute', top: 0, left: 0, width: '100%', willChange: 'transform' } })

type StyledLogoProps = { $color: string }
export const StyledLogo = chakra<typeof VerbitLogoChromakey, StyledLogoProps>(VerbitLogoChromakey, {
    baseStyle: ({ $color, theme }) => ({
        color: $color,
        width: `${GREEN_CHROMAKEY_LOGO_WIDTH}px`,
        height: '100%',
        padding: `${TRANSCRIPT_FULL_WIDTH_PADDING / 2}px`,
        [`@container (max-width: ${theme.breakPoints.tabletMaxWidth}px)`]: { display: 'none' },
    }),
    shouldForwardProp,
})
